import style from './style.module.scss'
import { Helmet } from 'react-helmet'
import { Loader } from '@crossfit/ui'
import RedirectPage from 'pages/Redirect'
import Hero from 'components/Hero'
import VideoList from 'components/VideoList'
import TextBlock from 'components/TextBlock'
import CuratedContentList from 'components/CuratedContentList'
import { useDynamicPage } from 'hooks/useDynamicPage'
import { toCamelCase } from 'utilities/toCamelCase'
import { Tile } from 'types/Page'
import FAQModule from 'components/FAQModule'

type Props = {
  tile: Tile
}

function DynamicPage({ tile }: Props) {
  const { meta, acf, breadcrumbs, slug, title } = tile

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta content={title} property='og:title' />
        <meta content={slug} property='og:url' />
        <meta content='website' property='og:type' />
        {/* TODO: request meta description */}
      </Helmet>
      <main className={style.page}>
        {acf.components.map((component, i) => {
          const name = component.acfFcLayout
          const key = `${name}-${i}`
          const props = component[toCamelCase(name)]

          switch (name) {
            case 'hero':
              return <Hero key={key} {...props} />
            case 'text_block':
              return <TextBlock key={key} {...props} />
            case 'video_list':
              return <VideoList key={key} {...props} />
            case 'curated_content_list':
              return <CuratedContentList key={key} {...props} />
            case 'faqs':
              return <FAQModule key={key} {...component['faqModule']} />
            default:
              return null
          }
        })}
      </main>
    </>
  )
}

function DynamicPageContainer() {
  const page = useDynamicPage(location.pathname)

  if (page.isLoading) {
    return <Loader /> // page style loader -- component list skeleton
  }

  if (page.isError) {
    return <RedirectPage />
  }

  return <DynamicPage tile={page.data} />
}

export default DynamicPageContainer
